import React from "react";
import { NotificationsType } from "../../api/@types/globalTypes";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { useAuth } from "../../context/AuthContext";
type NotificationCardProps = {
  notification: NotificationsType;
  onClick: (id: string | number) => void;
};
export default function NotificationCard(props: NotificationCardProps) {
  const { notification, onClick } = props;
  const { i18n } = useTranslation();
  const { userType }: any = useAuth();
  return (
    <div
      className="w-full px-3 py-4  cursor-pointer border-b border-gray-100 flex justify-between items-center"
      onClick={() => {
        if (!notification?.seen) {
          onClick(notification?.id);
        }
      }}
    >
      <div className="flex gap-2.5  flex-1 items-center">
        <div className="w-12 h-[52px] relative">
          <img
            className="w-10 h-10 left-0 top-0 absolute rounded-full object-cover"
            src={notification?.receiver_profile_picture_url ?? ""}
            alt=""
          />
          <img
            className="w-8 h-8 left-4 top-5 absolute rounded-full border border-white object-cover"
            src={notification?.source_profile_picture_url ?? ""}
            alt=""
          />
        </div>
        <div className=" flex-col justify-center items-center  inline-flex">
          <div className="  text-gray-600 text-sm font-semibold">
            {i18n?.language === "ar"
              ? notification?.message_ar
              : notification?.message_en}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-[6px] items-end">
        {((!notification?.seen_by_supervisor_id && userType === "supervisor") ||
          (!notification?.seen && userType !== "supervisor")) && (
          <span className="w-3 h-3 bg-brandblue-500 rounded-full" />
        )}
        <p className="text-gray-400 text-[10px] leading-4 ">
          {moment(notification?.created_at).fromNow()}
        </p>
      </div>
    </div>
  );
}
